import IPermissionContextState from 'Models/PermissionContextModel'
import { useAppDispatch, useAppSelector } from 'Store/selectors'
import { useNavigate } from 'react-router-dom'
import React from 'react'
import WithUserContext from 'Hoc/WithUserContext'
import { useTranslation } from 'react-i18next'
import DrawerMenu from 'Layouts/DrawerMenu/DrawerMenu'
import { setDrawerVisible } from 'Application/Common/store'
import LogoImage from 'assets/images/logo.svg'
import CarImage from 'assets/images/car.png'
import Icon from 'Components/Icon'
import NetStatus from 'Components/NetStatus'
import NotificationPaths from 'Application/Notification/Constants/NotificationPaths'

type IProps = IPermissionContextState

const HomePage = (props: IProps) => {
  const [t] = useTranslation()
  const { drawerVisible } = useAppSelector(store => store.common)
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  return (
    <React.Fragment>
      <div className="flex justify-between items-center h-16 px-6 shrink-0">
        <div className="flex justify-between items-center gap-2">
          <div onClick={() => dispatch(setDrawerVisible(!drawerVisible))}>
            <Icon name="menu" className="w-6 h-6 text-gray-700" />
          </div>
          <div className="text-lg font-bold pl-2">{t('VISIT')}</div>
        </div>
        <div className="flex justify-between items-center">
          <NetStatus />
          <div className="relative" style={{ marginRight: '8px' }}>
            <Icon
              name="notification"
              className="w-6 h-6 text-gray-600"
              onClick={() => {
                navigate(NotificationPaths.NotificationMain)
              }}
            />
            {/* <span className="w-[10px] h-[10px] rounded-full bg-error absolute left-0 top-0" /> */}
          </div>
        </div>
      </div>

      <DrawerMenu
        drawerVisible={drawerVisible}
        setDrawerVisible={(visible: boolean) => dispatch(setDrawerVisible(visible))}
      />

      <div className="flex flex-col grow overflow-auto">
        <div className="flex flex-col gap-4 px-6">
          <div className="flex items-center gap-4">
            <img
              alt="logo"
              src={LogoImage}
              style={{
                height: '120px',
                width: '100px',
                marginTop: '8px',
                marginRight: 'auto',
                marginLeft: 'auto',
              }}
            />
          </div>
          <div className="flex gap-6 rounded-xl h-48 p-4 bg-primary text-white items-center">
            <img src={CarImage} className="h-full" alt="" />
            <div className="px-2">
              <span className="text-lg font-bold">آسان تر از همیشه</span>
              <p className="text-sm">
                سریع، ساده، مطمئن
                <br />
                ارزیابی در دستان شما
              </p>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div
              className="flex flex-col items-center gap-4 text-primary bg-secondary/10 hover:bg-secondary/15 rounded-xl py-10 px-4 text-center"
              onClick={() => navigate('/visits')}
            >
              <Icon name="clipboard-text-bulk" className="w-[40px] h-[40px]" />
              <span className="text-base font-semibold">بازدید صدور</span>
            </div>
            <div
              className="flex flex-col items-center gap-4 text-primary bg-secondary/10 hover:bg-secondary/15 rounded-xl py-10 text-center px-4"
              style={{ opacity: 0.5, pointerEvents: 'none' }}
            >
              <Icon
                name="profile-2user-bulk"
                className="w-[40px] h-[40px]"
                style={{ color: '#b0b0b0' }}
              />
              <span className="text-base font-semibold" style={{ color: '#b0b0b0' }}>
                مشتریان
              </span>
            </div>
            <div
              className="flex flex-col items-center gap-4 text-primary bg-secondary/10 hover:bg-secondary/15 rounded-xl py-10  text-center px-4 col-span-2"
              style={{ opacity: 0.5, pointerEvents: 'none' }}
            >
              <Icon name="moneys-bulk" className="w-[40px] h-[40px]" style={{ color: '#b0b0b0' }} />
              <span className="text-base font-semibold" style={{ color: '#b0b0b0' }}>
                درخواست خسارت
              </span>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default WithUserContext(HomePage)
